import React from 'react';
import { Collapse, Grid, Typography } from 'antd';
import { Param } from '../../cliDataSchema';
import CollectionForm from './CollectionForm';

type Props = {
  featureGroups: Record<string, Record<string, Param[]>>;
};

const ProjectPresetsCollection: React.FC<Props> = ({ featureGroups }) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const generateCollapseSections = () => {
    return Object.entries(featureGroups).flatMap(
      ([featureGroupName, paramGroups]) => {
        return Object.entries(paramGroups)
          .filter(([, params]) => params.length > 0)
          .map(([paramGroupName, params]) => {
            const panelKey = `${featureGroupName}-${paramGroupName}`;

            return (
              <Collapse
                key={panelKey}
                accordion
                style={{ marginBottom: 6, marginTop: 6 }}
              >
                <Collapse.Panel header={paramGroupName} key={panelKey}>
                  <CollectionForm
                    paramGroupName={paramGroupName}
                    params={params}
                    screens={screens}
                  />
                </Collapse.Panel>
              </Collapse>
            );
          });
      },
    );
  };

  return (
    <div>
      {Object.keys(featureGroups).length > 0 ? (
        generateCollapseSections()
      ) : (
        <Typography.Paragraph>
          No parameters available. Please check your CLI data.
        </Typography.Paragraph>
      )}
    </div>
  );
};

export default ProjectPresetsCollection;
